import store from '../../store'

/**
 * Returns all sessions
 * @returns a list of all user sessions
 */
export function getAllSessions () {
  return store.getters.userSessions
}

/**
 * Get the current session
 * Use store.getters.currentSession instead! it's reactive
 * @returns the current session as an object or an empty session if no session
 */
export function getCurrentSession () {
  return store.getters.currentSession
}

/**
 * Get the current session index.
 * You shouldn't really use this though, it's not reactive.  Use
 * store.state.ui.currentSessionIndex instead
 * This is a value stored in the browser's session storage.
 * @returns {number}
 */
export function _getCurrentSessionIndex () {
  return parseInt(sessionStorage.getItem('userSessionIndex') || 0)
}

/**
 * Sets the current session index.
 * Always use this to update the current session index
 * The value is stored in the browser's session storage.
 * @param index
 */
export async function setCurrentSessionIndex (index) {
  sessionStorage.setItem('userSessionIndex', index)
  store.commit('setCurrentSessionIndex', index)
  await store.dispatch('setTreeRoot', getCurrentSession().rootNoteId || null)
}

/**
 * Set the expanded tree not ids for this session
 * @param changes an object with the fields to change in the session
 * @returns {Promise<any>} a promise that resolves once the session has been updated
 */
export function updateCurrentSession (changes) {
  let sessionClone = Object.assign({}, getCurrentSession())
  sessionClone = Object.assign(sessionClone, changes)
  return store.dispatch('updateUserSession', {
    index: store.state.ui.currentSessionIndex,
    session: sessionClone
  })
}

/**
 * Expands a note in the current session tree.
 * @param noteId  the note Id to expand
 * @returns {Promise<any>} a promise that resolves once the session has been updated
 * @see expandTreeNoteId
 */
export function expandNoteIdInTree (noteId) {
  let expandedTreeNoteIds = getCurrentSession().expandedTreeNoteIds.slice(0)
  // If the note is already expanded, just return
  if (expandedTreeNoteIds.indexOf(noteId) > -1) return Promise.all([])
  expandedTreeNoteIds.push(noteId)
  return updateCurrentSession({ expandedTreeNoteIds })
}

/**
 * Contracts (closes - un-expands) a note in the current session tree.
 * @param noteId  the note Id to contract
 * @returns {Promise<any>} a promise that resolves once the session has been updated
 * @see expandTreeNoteId
 */
export function collapseNoteIdInTree (noteId) {
  let expandedTreeNoteIds = getCurrentSession().expandedTreeNoteIds.slice(0)
  let index = expandedTreeNoteIds.indexOf(noteId)
  if (index === -1) return Promise.all([])
  expandedTreeNoteIds.splice(index, 1)
  return updateCurrentSession({ expandedTreeNoteIds })
}

/**
 * Sets the name of the current session
 * @param name  the new name
 * @returns {Promise<any>} a promise that resolves once the session has been updated
 */
export function renameCurrentSession (name) {
  return updateCurrentSession({ name })
}
